import HeaderComponent from '../../../../../components/HeaderComponent';
import { DataCard, IconSendRegular, skinVars, Tag, Text2, Text3, Text6, useWindowSize } from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { ICommunicationDetail } from '../../../../../models/Bills.interfaces';
import { formatMobileNumber } from '../../../../../utils/dataTransformation/unitsConversion';
import dayjs from 'dayjs';

const CommunicationsDetail = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const size = useWindowSize();
    const { message, title, shippingMethod, sendDate, statusName, contact, code, messageHtml }: ICommunicationDetail =
        state;

    const navigationBackHandler = () => navigate(`/claims/communications-list?code=${code}`);

    return (
        <>
            <HeaderComponent
                title={t('communicationDetails')}
                navigationBarOnBack={navigationBackHandler}
                breadcrumbs={[
                    { title: t('invoice'), url: '/bills' },
                    { title: t('billsClaimsHistory'), url: '/claims/claim-list' },
                    { title: t('ClaimDetails'), url: '/claims/claim-detail' },
                    { title: t('Communications'), url: `/claims/communications-list?code=${code}` },
                ]}
            />
            <div className='communication-details'>
                <div className='communication-details__header'>
                    <Text6 color={skinVars.colors.textPrimary}>{title}</Text6>
                </div>
                <div className='communication-details__text'>
                    <Text3 color={skinVars.colors.textSecondary} medium>
                        {code}
                    </Text3>
                </div>
                <div className='communication-details__card'>
                    <DataCard
                        title={shippingMethod === '1' ? contact : formatMobileNumber(contact)}
                        description={dayjs(sendDate).format('DD/MM/YYYY')}
                        headline={
                            <div className='communication-details__tag'>
                                <Tag type='success' Icon={IconSendRegular}>
                                    {statusName}
                                </Tag>
                            </div>
                        }
                        extra={
                            <div>
                                {message ? (
                                    <>
                                        <div className='communication-details__box-title'>
                                            <Text2 color={skinVars.colors.textPrimary} regular>
                                                {t('contentCommunication')}
                                            </Text2>
                                        </div>
                                        <div className='communication-details__box-text'>{message}</div>
                                    </>
                                ) : messageHtml ? (
                                    <>
                                        <div className='communication-details__box-title'>
                                            <Text2 color={skinVars.colors.textPrimary} regular>
                                                {t('contentCommunication')}
                                            </Text2>
                                        </div>
                                        <iframe
                                            srcDoc={messageHtml}
                                            width='100%'
                                            style={{ minHeight: '680px', border: 'none' }}
                                            scrolling='auto'
                                            title='communication-content'
                                        ></iframe>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        }
                    />
                </div>
            </div>
        </>
    );
};

export default CommunicationsDetail;
